import { render, staticRenderFns } from "./RevenueInvoices.vue?vue&type=template&id=6016a9e0&scoped=true"
import script from "./RevenueInvoices.vue?vue&type=script&lang=js"
export * from "./RevenueInvoices.vue?vue&type=script&lang=js"
import style0 from "./RevenueInvoices.vue?vue&type=style&index=0&id=6016a9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016a9e0",
  null
  
)

export default component.exports